"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PropTypes = require("prop-types");

var React = require("react");

var classNames = require("classnames");

var withStyles_1 = require("../decorators/withStyles");

var mixins_1 = require("../theme/mixins");

exports.InputGroupContextTypes = {
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  setFocus: PropTypes.func,
  setHover: PropTypes.func
};

var Divider =
/** @class */
function (_super) {
  __extends(Divider, _super);

  function Divider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Divider.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        hover = _b.hover,
        focus = _b.focus,
        disabled = _b.disabled,
        invalid = _b.invalid,
        secondary = _b.secondary;
    return React.createElement("div", {
      className: classNames(classes.base, (_a = {}, _a[classes.hover] = !!hover, _a[classes.focus] = !!focus, _a[classes.disabled] = !!disabled, _a[classes.invalid] = !!invalid, _a[classes.secondary] = !!secondary, _a))
    }, "\xA0");
  };

  Divider = __decorate([withStyles_1.withStyles(function (theme) {
    var sizeBorderWidth = theme.sizeBorderWidth,
        colorBorder = theme.colorBorder,
        colorError = theme.colorError,
        colorBgSecondary = theme.colorBgSecondary;
    return {
      base: {
        display: 'inline-block',
        width: sizeBorderWidth,
        transition: 'background-color 0.3s',
        backgroundColor: mixins_1.calculateBorderColor(colorBorder.normal)
      },
      hover: {
        backgroundColor: mixins_1.calculateBorderColor(colorBorder.hover)
      },
      focus: {
        backgroundColor: mixins_1.calculateBorderColor(colorBorder.active)
      },
      invalid: {
        backgroundColor: colorError.normal,
        '&$hover': {
          backgroundColor: mixins_1.calculateBorderColor(colorError.hover)
        },
        '&$focus': {
          backgroundColor: mixins_1.calculateBorderColor(colorError.active)
        }
      },
      secondary: {
        backgroundColor: colorBgSecondary.normal,
        '&$hover': {
          backgroundColor: colorBgSecondary.hover
        },
        '&$focus': {
          backgroundColor: colorBgSecondary.active
        }
      },
      disabled: {}
    };
  })], Divider);
  return Divider;
}(React.Component); // tslint:disable-next-line:max-classes-per-file


var InputGroupCell =
/** @class */
function (_super) {
  __extends(InputGroupCell, _super);

  function InputGroupCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputGroupCell.prototype.getChildContext = function () {
    var _a = this.props,
        first = _a.first,
        last = _a.last,
        setFocus = _a.setFocus,
        setHover = _a.setHover;
    return {
      isFirst: !!first,
      isLast: !!last,
      setFocus: setFocus,
      setHover: setHover
    };
  };

  InputGroupCell.prototype.render = function () {
    var _a = this.props,
        child = _a.child,
        divider = _a.divider,
        hover = _a.hover,
        focus = _a.focus,
        disabled = _a.disabled,
        invalid = _a.invalid,
        secondary = _a.secondary;

    if (divider) {
      return React.createElement(Divider, {
        hover: hover,
        focus: focus,
        disabled: disabled,
        invalid: invalid,
        secondary: secondary
      });
    }

    return React.Children.only(child);
  };

  InputGroupCell.childContextTypes = exports.InputGroupContextTypes;
  return InputGroupCell;
}(React.Component);

exports.default = InputGroupCell;